import qs from 'query-string';

import { verifyEntityExists } from '../../api/entity';
import {
  ALPHANUMERIC_VALIDATION_TEXT,
  REQUIRED_VALIDATION_TEXT,
  SPECIAL_CHARS,
} from '../../constants/Common';
import { isNilOrEmpty } from '../../utils/ramdaUtils';
import {
  ENTITY_TYPE_CHILD,
  ENTITY_TYPE_MASTER_SETUP_PARENT,
  ENTITY_TYPE_PARENT,
} from '../constants/entity-designer.constants';

export const validateNewEntityProp = ({ propValue }) => {
  const error = {};
  if (isNilOrEmpty(propValue)) {
    error.hasError = true;
    error.errorText = REQUIRED_VALIDATION_TEXT;
  } else if (SPECIAL_CHARS.test(propValue)) {
    error.hasError = true;
    error.errorText = ALPHANUMERIC_VALIDATION_TEXT;
  } else {
    error.hasError = false;
    error.errorText = '';
  }
  return error;
};

export const validateNewEntityModalOnBlur = ({ entitySettings, propName, modalErrors }) => {
  const errors = { ...modalErrors };

  const propError = validateNewEntityProp({ propValue: entitySettings[propName] });
  errors[propName] = { ...propError };

  return errors;
};

export const validateNewEntityModalOnCreate = async ({
  entityName,
  tableName,
  useGenericTable,
}) => {
  const errors = { entityName: {}, tableName: {} };

  if (!entityName.length) {
    errors.entityName.hasError = true;
    errors.entityName.errorText = 'This field is required';
  }

  if (!useGenericTable && !tableName.length) {
    errors.tableName.hasError = true;
    errors.tableName.errorText = 'This field is required';
  }

  if (errors.entityName.hasError || errors.tableName.hasError) {
    return errors;
  }

  const isEntityExist = await verifyEntityExists({ entityName });

  if (isEntityExist) {
    errors.entityName.hasError = true;
    errors.entityName.errorText = 'This entity already exists';
  }

  return errors;
};

export const getNewEntityParams = ({
  entityName,
  entityType,
  useGenericTable,
  runtimeTable,
  tableName,
}) => {
  const entityTypeObject =
    entityType === ENTITY_TYPE_PARENT
      ? { isParent: true, isMasterSetup: false }
      : entityType === ENTITY_TYPE_CHILD
      ? { isParent: false, isMasterSetup: false }
      : entityType === ENTITY_TYPE_MASTER_SETUP_PARENT
      ? { isParent: true, isMasterSetup: true }
      : { isParent: false, isMasterSetup: true };
  return {
    ...entityTypeObject,
    entityName,
    entityViewName: useGenericTable ? `V_${entityName}` : tableName,
    isWFEnabled: entityType === ENTITY_TYPE_PARENT,
    isGenericTable: useGenericTable,
    runtimeTable,
  };
};

export const getNewEntityLink = ({ entityName, entityType, useGenericTable, tableName }) => {
  const newEntityParams = {
    entityName,
    entityType,
    useGenericTable,
    runtimeTable: tableName,
    isNewEntity: true,
    standaloneLayout: true,
  };
  const stringifyParams = qs.stringify(newEntityParams);

  return `entity-editor?${stringifyParams}`;
};
